module.exports = __webpack_public_path__ + "img/cta-bg.b53dd3a2.png";